type BlockchainType = "evm" | "demo" | "ton";

type ScoreValue = {
  type: BlockchainType;
  name: string;
  apiEndpoint: string;
  scoreType: number;
  chainId: bigint;
  calculationModel: number;
  abi: [];
  contract: string;
  referrals?: boolean;
  twitterHashtags?: string[];
  uri: string;
};

export type Score = keyof typeof scores;

export const scores = {
  ton: {
    type: "ton",
    name: "Ton",
    apiEndpoint: "ton",
    scoreType: 0,
    // chainId: 0,
    calculationModel: 11,
    abi: [],
    contract: "EQBykWvdmoyFD2kB4BJbdrxRqyWKzSLDn-SgwNvznRfbsaKv",
    // referrals: true,
    twitterHashtags: ["#Ton", "#Nomis"],
    uri: "/ton",
  } as unknown as ScoreValue,
};
